document.addEventListener('DOMContentLoaded', function () {
  gsap.registerPlugin(ScrollTrigger);

  /* -- Porta la modale DENTRO il <dialog> e gestisci lo stack -- */
  (() => {
    const DIALOG_SEL = 'cart-drawer-component dialog.cart-drawer__dialog.dialog-modal.dialog-drawer';
    const MODAL_SEL  = 'invoice-modal';

    function moveInsideDialog() {
      const dlg = document.querySelector(DIALOG_SEL);
      const modal = document.querySelector(MODAL_SEL);
      if (!dlg || !modal) return;

      // Appendila come ULTIMO figlio del <dialog> (non dentro .cart-drawer__inner)
      if (!dlg.contains(modal)) dlg.appendChild(modal);
    }

    function ensureStyles() {
      if (document.getElementById('invoice-in-drawer-styles')) return;
      const s = document.createElement('style');
      s.id = 'invoice-in-drawer-styles';
      s.textContent = `
        /* La modale copre tutto lo stack del drawer */
        ${DIALOG_SEL} ${MODAL_SEL}{
          position: fixed !important;
          inset: 0 !important;
          z-index: 2147483647 !important; /* sopra a tutto */
        }

        /* Quando la modale è aperta, ammutolisci wallet/iframe */
        html.invoice-open .dynamic-checkout__content,
        html.invoice-open shopify-accelerated-checkout-cart,
        html.invoice-open .paypal-buttons iframe,
        html.invoice-open shopify-google-pay-button iframe {
          opacity: 0 !important;
          pointer-events: none !important;
        }
      `;
      document.head.appendChild(s);
    }

    function isOpen(modal){
      if (!modal) return false;
      const cs = getComputedStyle(modal);
      return cs.display !== 'none' && !modal.classList.contains('fi-hidden') &&
            modal.getAttribute('aria-hidden') !== 'true' && !modal.hasAttribute('hidden');
    }

    function watchOpenClose() {
      const modal = document.querySelector(MODAL_SEL);
      if (!modal || modal.__watching) return;
      modal.__watching = true;
      const toggle = () => document.documentElement.classList.toggle('invoice-open', isOpen(modal));
      new MutationObserver(toggle)
        .observe(modal, { attributes: true, attributeFilter: ['class','style','open','hidden','aria-hidden'] });
      toggle();
    }

    function keepReparented() {
      new MutationObserver(() => {
        const dlg = document.querySelector(DIALOG_SEL);
        const modal = document.querySelector(MODAL_SEL);
        if (dlg && modal && !dlg.contains(modal)) dlg.appendChild(modal);
      }).observe(document.documentElement, { childList: true, subtree: true });
    }

    ensureStyles();
    moveInsideDialog();
    watchOpenClose();
    keepReparented();

    // ritenti nel caso i componenti montino tardi
    setTimeout(moveInsideDialog, 200);
    setTimeout(moveInsideDialog, 600);
  })();


  /* Chiusura accordion filtri prodotti pagina collezione */
  const seeResultsBtn = document.querySelector('.facets__see-results');
  const accordion = document.querySelector('.facets-accordion');

  if (seeResultsBtn && accordion) {
    seeResultsBtn.addEventListener('click', () => {
      accordion.removeAttribute('open');
    });
  }

  /* Fix per mostrare tutti elmeneti del filtro */
  document.querySelectorAll("overflow-list").forEach(list => {
    if (typeof list.showAll === "function") list.showAll();
  });

  /* ===============================
   *  Gestione colore badge fragranza
   * =============================== */
  function parseColor(input) {
    if (!input) return null;
    input = String(input).trim();

    // HEX (#rgb, #rgba, #rrggbb, #rrggbbaa)
    if (input.startsWith('#')) {
      let hex = input.slice(1);
      if (hex.length === 3 || hex.length === 4) hex = hex.split('').map(c => c + c).join('');
      if (hex.length === 6 || hex.length === 8) {
        const r = parseInt(hex.slice(0, 2), 16);
        const g = parseInt(hex.slice(2, 4), 16);
        const b = parseInt(hex.slice(4, 6), 16);
        return [r, g, b]; // alpha ignorata
      }
      return null;
    }

    const m = input.match(/rgba?\(([^)]+)\)/i);
    if (m) {
      const parts = m[1].split(',').map(v => parseFloat(v.trim()));
      if (parts.length >= 3) return [parts[0], parts[1], parts[2]];
    }

    return null;
  }

  function luminanceFromRGB([r, g, b]) {
    return (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  }

  function getBadgeBgColor(el) {
    const varColor = el.style.getPropertyValue('--tag-color') || getComputedStyle(el).getPropertyValue('--tag-color');
    let rgb = parseColor(varColor);
    if (rgb) return rgb;

    rgb = parseColor(getComputedStyle(el).backgroundColor);
    if (rgb) return rgb;

    let p = el.parentElement;
    while (p) {
      const pbg = getComputedStyle(p).backgroundColor;
      const prgb = parseColor(pbg);
      if (prgb && !(pbg.includes('0)'))) return prgb; // evita fully transparent
      p = p.parentElement;
    }
    return [255, 255, 255]; // assume chiaro
  }

  function setBadgeTextColor(el) {
    const rgb = getBadgeBgColor(el);
    const lum = luminanceFromRGB(rgb);
    const color = lum > 0.5 ? '#000' : '#fff';
    el.style.color = color;
    const inner = el.querySelector?.('.product-badge_fragranza__text');
    if (inner) inner.style.color = color;
  }

  function updateAllTagColors() {
    document
      .querySelectorAll('.product-badge_fragranza, .intestazione_prodotto p, .product-badge_fragranza p')
      .forEach(setBadgeTextColor);
  }

  // Primo pass dopo il layout
  requestAnimationFrame(updateAllTagColors);
  window.addEventListener('load', updateAllTagColors);

  // Ricalcolo su mutazioni dinamiche
  const mo = new MutationObserver(mutations => {
    let needsUpdate = false;
    for (const m of mutations) {
      if (m.type === 'childList') {
        for (const n of m.addedNodes) {
          if (n.nodeType === 1 && (n.matches?.('.product-badge_fragranza') || n.querySelector?.('.product-badge_fragranza'))) {
            needsUpdate = true;
            break;
          }
        }
      }
      if (needsUpdate) break;
    }
    if (needsUpdate) updateAllTagColors();
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  /* ===============================
   *  Helpers contrasto collezione (UNA SOLA COPIA)
   * =============================== */
  function getCssVarRgb(varName, scope = document.documentElement) {
    const val = getComputedStyle(scope).getPropertyValue(varName);
    return parseColor(val);
  }

  function pickContrastColorFrom(bgRgb) {
    if (!bgRgb) return '#000';
    const lum = luminanceFromRGB(bgRgb);
    return lum > 0.5 ? '#000' : '#fff';
  }

  /* ===============================
   *  Contrasto testo collezione → solo var CSS (niente style inline su h1/p)
   * =============================== */
  function applyCollectionTextContrastVar() {
    const main = document.querySelector('main[data-template="collection.fragrance-collection"]');
    if (!main) return;

    let rgb = getCssVarRgb('--collection-color', document.documentElement);
    if (!rgb) rgb = parseColor(getComputedStyle(main).backgroundColor);

    const text = pickContrastColorFrom(rgb);

    const targets = [ 
      '.hero_collection', 
      '.hero_collection h1', 
      '.hero_collection p'
    ];
    targets.forEach(sel => { 
      main.querySelectorAll(sel).forEach(el => { el.style.color = text; }); 
    });
  }

  requestAnimationFrame(applyCollectionTextContrastVar);
  window.addEventListener('load', applyCollectionTextContrastVar);
  document.addEventListener('shopify:section:load', applyCollectionTextContrastVar);
  document.addEventListener('shopify:section:reorder', applyCollectionTextContrastVar);
  window.addEventListener('locationchange', () => requestAnimationFrame(applyCollectionTextContrastVar));
  const collectionColorObserver = new MutationObserver(applyCollectionTextContrastVar);
  collectionColorObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['style', 'class'] });

  /* ===============================
   *  Bottoni collezione → secondary / quaternary (usa gli stessi helpers)
   * =============================== */
  function applyCollectionButtonClass() {
    const main = document.querySelector('main[data-template="collection.fragrance-collection"]');
    if (!main) return;

    let rgb = getCssVarRgb('--collection-color', document.documentElement);
    if (!rgb) rgb = parseColor(getComputedStyle(main).backgroundColor);

    const text = pickContrastColorFrom(rgb);
    const newClass = (text === '#fff') ? 'button-quaternary' : 'button-secondary';

    main.querySelectorAll('.hero_collection a, .hero_collection .button, .hero_collection button')
      .forEach(el => {
        el.classList.remove('button-quaternary', 'button-secondary');
        el.classList.add(newClass);
      });
  }

  requestAnimationFrame(applyCollectionButtonClass);
  window.addEventListener('load', applyCollectionButtonClass);
  document.addEventListener('shopify:section:load', applyCollectionButtonClass);
  document.addEventListener('shopify:section:reorder', applyCollectionButtonClass);
  window.addEventListener('locationchange', () => requestAnimationFrame(applyCollectionButtonClass));

  /* Testo circolare che ruota (scroll to next section) */
  document.querySelectorAll('.circle-wrapper').forEach(wrapper => {
    wrapper.addEventListener('click', (e) => {
      e.preventDefault();
      const currentSection = wrapper.closest('.shopify-section');
      let nextSection = currentSection?.nextElementSibling;
      while (nextSection && !nextSection.classList.contains('shopify-section')) {
        nextSection = nextSection.nextElementSibling;
      }
      if (nextSection) nextSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  /* ===============================
  *  Overlay offset + snap panels + parallax (invariati)
  * =============================== */
  function computeTopOffset() {
    const header = document.querySelector('header-component');
    const headerHeight = header ? header.getBoundingClientRect().height || header.offsetHeight || 0 : 0;

    const bar = document.querySelector('.announcement-bar');
    let announcementOffset = 0;

    if (bar) {
      const rect = bar.getBoundingClientRect();
      const pos = getComputedStyle(bar).position;
      const isFixedOrSticky = pos === 'fixed' || pos === 'sticky';
      const touchesTop = rect.top <= 0 && rect.bottom > 0;
      const fullyBelowTop = rect.top >= 0;

      if (touchesTop) {
        announcementOffset = Math.min(rect.height, rect.bottom);
      } else if (fullyBelowTop && isFixedOrSticky) {
        announcementOffset = rect.height;
      }
    }

    return Math.max(0, headerHeight + announcementOffset - 1);
  }

  const OVERLAY_STYLE_ID = 'overlay-top-style';

  function ensureOverlayStyle() {
    let styleEl = document.getElementById(OVERLAY_STYLE_ID);
    if (!styleEl) {
      styleEl = document.createElement('style');
      styleEl.id = OVERLAY_STYLE_ID;
      document.head.appendChild(styleEl);
    }
    // Metti qui tutti i selettori degli overlay che devono rispettare l’offset
    styleEl.textContent = `
      dialog.search-modal__content,
      .account-popover__panel,
      [data-header-drawer],
      .menu-drawer__backdrop,
      .facets--drawer.dialog-modal {
        top: var(--overlay-top, 0px) !important;
      }
    `;
  }

  function applyTopToOverlays() {
    ensureOverlayStyle();
    const top = computeTopOffset();
    document.documentElement.style.setProperty('--overlay-top', `${top}px`);
  }

  function applyMediaHeight() {
    const top = computeTopOffset();
    let styleEl = document.getElementById('media-height-style');
    if (!styleEl) {
      styleEl = document.createElement('style');
      styleEl.id = 'media-height-style';
      document.head.appendChild(styleEl);
    }
    styleEl.textContent = `
      @media (width > 48rem) {
        .product-information__media, .essenza_profumo, .utilizzo {
          min-height: calc(100vh - ${top}px)!important;
          box-sizing: border-box;
        }
      }
    `;
  }

  function initSnaps() {
    const panels = gsap.utils.toArray(".product-information__media, .essenza_profumo, .utilizzo");
    if (panels.length === 0) return;

    ScrollTrigger.getAll().forEach(st => st.vars && st.vars.__snapPanel && st.kill());

    const getTop = () => (typeof computeTopOffset === "function" ? computeTopOffset() : 0);

    panels.forEach(panel => {
      ScrollTrigger.create({
        trigger: panel,
        start: () => `top-=${getTop()} top`,
        end:   () => `bottom-=${getTop()} top`,
        snap:  { snapTo: [0, 1], duration: 0.8, ease: "power2.out" },
        invalidateOnRefresh: true,
        __snapPanel: true
      });
    });

    ScrollTrigger.refresh();
  }

  window.addEventListener('load', () => {
    const mm = gsap.matchMedia();

    const setupParallax = () => {
      ScrollTrigger.getAll().forEach(st => {
        if (st.vars && st.vars.id && st.vars.id.startsWith('parallax-essenza')) st.kill();
      });

      document.querySelectorAll('.essenza_profumo .background-image-container img').forEach((img, i) => {
        const section = img.closest('.essenza_profumo');
        if (!section) return;

        gsap.set(img, {
          scale: 1.12,
          transformOrigin: 'center center'
        });

        const isDesktop = window.matchMedia('(min-width: 750px)').matches;
        const startY = isDesktop ? -8 : -4;
        const endY   = isDesktop ?  8 :  4;

        gsap.fromTo(img,
          { yPercent: startY },
          {
            yPercent: endY,
            ease: 'none',
            scrollTrigger: {
              id: `parallax-essenza-${i}`,
              trigger: section,
              start: 'top bottom',
              end: 'bottom top',
              scrub: 0.6,
              invalidateOnRefresh: true
            }
          }
        );
      });

      ScrollTrigger.refresh();
    };

    setupParallax();

    let resizeTO;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTO);
      resizeTO = setTimeout(() => setupParallax(), 150);
    });
  });

  // throttle con rAF
  let ticking = false;
  function scheduleUpdate() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      applyTopToOverlays();
      ticking = false;
    });
  }

  const isDesktop = () => window.matchMedia("(min-width: 768px)").matches;
  let snapEnabled = false;
  function enableDesktopSnap() {
    if (snapEnabled) {
      applyMediaHeight();
      ScrollTrigger.refresh();
      return;
    }
    applyMediaHeight();
    /* initSnaps(); */ //Commentati per il momento causavano bug nello scroll
    snapEnabled = true;
  }
  function disableDesktopSnap() {
    if (!snapEnabled) return;
    ScrollTrigger.getAll().forEach(st => {
      if (st.vars && st.vars.__snapPanel) st.kill();
    });
    snapEnabled = false;
  }

  // iniziale
  applyTopToOverlays();
  if (isDesktop()) enableDesktopSnap();

  window.addEventListener('resize', () => {
    scheduleUpdate();
    if (isDesktop()) enableDesktopSnap();
    else disableDesktopSnap();
  }, { passive: true });

  window.addEventListener('scroll', () => {
    scheduleUpdate();
  }, { passive: true });

  if (window.visualViewport) {
    visualViewport.addEventListener('resize', () => {
      scheduleUpdate();
      if (isDesktop()) enableDesktopSnap();
      else disableDesktopSnap();
    }, { passive: true });
    visualViewport.addEventListener('scroll', () => {
      scheduleUpdate();
    }, { passive: true });
  }

  // eventi Shopify
  document.addEventListener('shopify:section:load', () => {
    applyTopToOverlays();
    if (isDesktop()) enableDesktopSnap();
    else disableDesktopSnap();
  });
  document.addEventListener('shopify:section:reorder', () => {
    applyTopToOverlays();
    if (isDesktop()) enableDesktopSnap();
    else disableDesktopSnap();
  });
  window.addEventListener('pageshow', applyTopToOverlays);

  // quando si apre/chiude un <dialog> (es. search-modal)
  document.addEventListener('toggle', (evt) => {
    if (evt.target?.matches?.('dialog, dialog.search-modal, .facets--drawer.dialog-modal')) {
      scheduleUpdate();
    }
  });

  // osserva il drawer filtri e ricalcola se viene riaggiunto o gli cambiano attributi
  const overlaySelectors = '.facets--drawer.dialog-modal, dialog.search-modal__content, .account-popover__panel, [data-header-drawer], .menu-drawer__backdrop';
  const overlayObserver = new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.type === 'childList') {
        if ([...m.addedNodes].some(n => n.nodeType === 1 && (n.matches?.(overlaySelectors) || n.querySelector?.(overlaySelectors)))) {
          scheduleUpdate();
          break;
        }
      }
      if (m.type === 'attributes' && (m.target?.matches?.(overlaySelectors))) {
        scheduleUpdate();
        break;
      }
    }
  });
  overlayObserver.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style', 'class', 'open']
  });

  // hook alle variazioni di URL (pushState/replaceState/popstate) usate dai filtri
  (function (history) {
    const wrap = (type) => {
      const orig = history[type];
      return function () {
        const ret = orig.apply(this, arguments);
        window.dispatchEvent(new Event('locationchange'));
        return ret;
      };
    };
    history.pushState = wrap('pushState');
    history.replaceState = wrap('replaceState');
  })(window.history);
  window.addEventListener('popstate', () => window.dispatchEvent(new Event('locationchange')));
  window.addEventListener('locationchange', () => {
    // aspetta un frame per dare tempo al DOM di aggiornarsi
    requestAnimationFrame(applyTopToOverlays);
  });


  /* ===============================
  *  QUIZ FRAGRANZE — step + mapping + colore dinamico
  * =============================== */
  (function() {
    // esegui solo se siamo nella pagina "page.test-fragranza"
    const main = document.querySelector('main[data-template*="page.test-fragranza"]');
    if (!main) return;
    // ===== CONFIG =====
    const USE_ASSET   = true; // se leggi da Assets
    const ASSET_URL = (document.getElementById('quiz-config')?.dataset.quizUrl || '').trim();
    const RESULTS_MODE = 'redirect';
    const FALLBACK_HANDLE = 'all';
    const FALLBACK_TITLE  = 'Selezione generale';
    const LETTER_ORDER = {
      1: ['A','B','C'],
      2: ['A','B','C'],
      3: ['A','B','C'],
      4: ['A','B','C'],
      5: ['A','B','C']
    };

    // Palette provvisoria per domanda/lettera (A/B/C)
    // Scegli tu i colori (coerenti con brand/UX). Questi sono di esempio.
    const PALETTE = {
      1: { A:'#FFFDF1', B:'#FAF6F6', C:'#F6E9D6' },
      2: { A:'#F3F0ED', B:'#E9E4E1', C:'#FDF6F9' },
      3: { A:'#F9EDCF', B:'#E8EFDD', C:'#E9F5FA' },
      4: { A:'#E1E9D8', B:'#FDF6D6', C:'#F3F0ED' },
      5: { A:'#FAF4F7', B:'#FEF9E8', C:'#E7F5F0' }
    };

    // target da colorare
    const COLOR_TARGETS = [
      () => document.querySelector('.header__row'),
      () => document.querySelector('main')
    ];
    const DEFAULT_COLORS = (() => {
      const els = COLOR_TARGETS.map(get => get()).filter(Boolean);
      return els.map(el => getComputedStyle(el).backgroundColor || '');
    })();

    const BTN_SEL = {
      start:  '.quiz-start',
      prev:   '.quiz-prev',
      next:   '.quiz-next',
      finish: '.quiz-finish'
    };
    const getBtn = (stepEl, type) => stepEl.querySelector(BTN_SEL[type]);

    function resetThemeColor() {
      const els = COLOR_TARGETS.map(get => get()).filter(Boolean);
      els.forEach((el, i) => { el.style.backgroundColor = DEFAULT_COLORS[i] || ''; });
    }

    // stile base per transizioni (se non già presente)
    (function ensureQuizStyle(){
      const id = 'quiz-min-style';
      if (document.getElementById(id)) return;
      const s = document.createElement('style');
      s.id = id;
      s.textContent = `
        .risposta.is-selected p, .risposta:hover p { font-weight: 600; }
      `;
      document.head.appendChild(s);
    })();

    // ===== STATE =====
    const state = {
      stepIndex: 0,     // 0 = intro, poi 1..N domande
      answers: [],      // lettere A/B/C per domanda
      mapping: {}       // code -> {collection_handle, collection_title, color?}
    };

    // ===== UTILS =====
    const qsa = (sel, root=document) => Array.from(root.querySelectorAll(sel));
    const qs  = (sel, root=document) => root.querySelector(sel);
    const hide = el => { if (el) el.style.display = 'none'; };
    const show = el => { if (el) el.style.display = ''; };

    function collectQuizSteps() {
      const wrappers = qsa('.shopify-section.section-wrapper');
      const intro = wrappers.find(w => !w.querySelector('.section.section_to_hide'));
      const questions = wrappers.filter(w => w.querySelector('.section.section_to_hide'));
      const steps = [];
      if (intro) steps.push(intro);
      steps.push(...questions);
      return steps;
    }

    function centerSecondAnswer(stepEl) {
      const scroller =
        stepEl.querySelector('.domanda > .layout-panel-flex') ||
        stepEl.querySelector('.domanda .layout-panel-flex');
      if (!scroller) return;

      const answers = scroller.querySelectorAll('.risposta');
      const target = answers[1] || answers[0]; // prova la 2ª, fallback 1ª
      if (!target) return;

      // doppio rAF per aspettare layout/style/immagini
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          target.scrollIntoView({ behavior: 'auto', inline: 'center', block: 'nearest' });
        });
      });
    }

    function setActiveStep(steps, index) {
      // mostra solo lo step attivo
      steps.forEach((el, i) => i === index ? show(el) : hide(el));

      // reset colore di default
      resetThemeColor();

      // 🔹 disabilita tab su tutte le risposte (anche quelle nascoste)
      document.querySelectorAll('.risposta').forEach(el => { el.tabIndex = -1; });

      // 🔹 abilita tab solo sulle risposte dello step corrente e focus sulla prima
      const currentAnswers = steps[index].querySelectorAll('.risposta');
      currentAnswers.forEach(el => { el.tabIndex = 0; });
      if (currentAnswers[0]) {
        currentAnswers[0].focus({ preventScroll: true });
      }

      // da Q1 in poi (index 1..5): colore e ripristino selezione
      if (index >= 1) {
        const qNum = index;
        const saved = state.answers[qNum - 1];
        if (saved) {
          const hex = PALETTE[qNum]?.[saved];
          if (hex) setThemeColor(hex);
          const ansEls = steps[index].querySelectorAll('.risposta');
          ansEls.forEach(el => el.classList.toggle('is-selected', el.dataset.answer === saved));
        }

        // centra la 2ª risposta quando entri nella domanda
        centerSecondAnswer(steps[index]);
      }
    }


    // ===== COLOR HELPERS =====
    const hexToRgb = (hex) => {
      if (!hex) return null;
      const s = hex.replace('#','').trim();
      if (![3,6].includes(s.length)) return null;
      const full = s.length === 3 ? s.split('').map(c=>c+c).join('') : s;
      const r = parseInt(full.slice(0,2),16);
      const g = parseInt(full.slice(2,4),16);
      const b = parseInt(full.slice(4,6),16);
      return [r,g,b];
    };
    const rgbToHex = ([r,g,b]) => '#' + [r,g,b].map(n => {
      const v = Math.max(0, Math.min(255, Math.round(n)));
      return v.toString(16).padStart(2,'0');
    }).join('');

    function mixRgb(colors) {
      if (!colors.length) return [255,255,255];
      const acc = colors.reduce((a,c) => [a[0]+c[0], a[1]+c[1], a[2]+c[2]], [0,0,0]);
      return [ acc[0]/colors.length, acc[1]/colors.length, acc[2]/colors.length ];
    }

    // colore “provvisorio” in base alle risposte date finora (media dei colori scelti)
    function computeProvisionalColor() {
      const rgbs = [];
      state.answers.forEach((letter, i) => {
        const qn = i+1;
        const hex = PALETTE[qn]?.[letter];
        const rgb = hexToRgb(hex);
        if (rgb) rgbs.push(rgb);
      });
      const mixed = mixRgb(rgbs);
      return rgbToHex(mixed);
    }

    function setThemeColor(hex) {
      // usa GSAP se c'è, altrimenti fallback direttamente
      const targets = COLOR_TARGETS.map(get => get()).filter(Boolean);
      if (!targets.length) return;

      if (window.gsap) {
        targets.forEach(el => {
          gsap.to(el, { backgroundColor: hex, duration: 0.45, ease: 'power2.out' });
        });
      } else {
        targets.forEach(el => el.style.backgroundColor = hex);
      }
    }

    // ===== QUIZ LOGIC =====
    function attachAnswers(stepEl, stepNumber) {
      const answers = qsa('.risposta', stepEl);
      if (!answers.length) return;

      const nextInit = getBtn(stepEl, 'next') || getBtn(stepEl, 'finish');
      if (nextInit) nextInit.classList.add('is-disabled');

      answers.forEach((ansEl, i) => {
        const order  = LETTER_ORDER[stepNumber] || ['A','B','C'];
        const letter = order[i] || 'A';

        ansEl.dataset.answer = letter;
        ansEl.setAttribute('role','button');
        ansEl.tabIndex = -1;

        const mark = () => {
          // reset classi visive
          answers.forEach(a => {
            a.classList.remove('is-selected', 'dimmed');
            a.style.opacity = ''; // reset
          });

          // seleziona quella cliccata
          ansEl.classList.add('is-selected');

          // tutte le altre diventano dimmed
          answers.forEach(a => {
            if (a !== ansEl) {
              a.classList.add('dimmed');
              a.style.opacity = '0.2';
            }
          });

          // salva risposta
          state.answers[stepNumber - 1] = letter;

          const nextBtn = getBtn(stepEl, 'next') || getBtn(stepEl, 'finish');
          if (nextBtn) nextBtn.classList.remove('is-disabled');

          const hex = PALETTE[stepNumber] && PALETTE[stepNumber][letter];
          if (hex) setThemeColor(hex);
        };

        ansEl.addEventListener('click', mark);
        ansEl.addEventListener('keydown', ev => {
          if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); mark(); }
        });
      });
    }

    function buildCode() {
      if (!state.answers.length) return null;
      if (state.answers.some(a => !a)) return null;
      return state.answers.join('');
    }

    function goResults(code) {
      const hit = state.mapping[code];

      if (!hit && !FALLBACK_HANDLE) {
        alert('Combinazione non trovata. Riprova o contattaci.');
        return;
      }
      const handle = (hit && hit.collection_handle) || FALLBACK_HANDLE;
      const title  = (hit && hit.collection_title)  || FALLBACK_TITLE;

      if (RESULTS_MODE === 'redirect') {
        window.location.href = '/collections/' + handle;
        return;
      }
    }

    async function loadMapping() {
      try {
        if (USE_ASSET) {
          if (!ASSET_URL) throw new Error('Asset URL mancante: aggiungi il #quiz-config con data-quiz-url');
          const r = await fetch(ASSET_URL, { credentials: 'same-origin', cache: 'no-store' });
          if (!r.ok) throw new Error(`Fetch fallita: ${r.status} ${r.statusText}`);
          const data = await r.json();
          const m = data?.mapping || data;
          state.mapping = (m && typeof m === 'object') ? m : {};
        } else {
          const raw = document.getElementById('quiz-data')?.textContent || '{}';
          const data = JSON.parse(raw);
          const m = data?.mapping || data;
          state.mapping = (m && typeof m === 'object') ? m : {};
        }
      } catch(e) {
        console.warn('Quiz mapping non disponibile', e);
        state.mapping = {};
      }
    }

    // ===== INIT =====
    (async function initQuiz(){
      const steps = collectQuizSteps();
      if (!steps.length) return;

      state.stepIndex = 0; // mostra intro
      setActiveStep(steps, state.stepIndex);

      steps.forEach((stepEl, i) => {
        const start = getBtn(stepEl, 'start');
        if (start) start.addEventListener('click', (ev) => {
          ev.preventDefault();
          state.stepIndex = Math.min(1, steps.length - 1);
          setActiveStep(steps, state.stepIndex);
        });

        const prev = getBtn(stepEl, 'prev');
        if (prev) prev.addEventListener('click', (ev) => {
          ev.preventDefault();
          state.stepIndex = Math.max(0, state.stepIndex - 1);
          setActiveStep(steps, state.stepIndex);
        });

        // continua o scopri i risultati (multilingua-safe, solo classi)
        const nextOrFinish = getBtn(stepEl, 'next') || getBtn(stepEl, 'finish');
        if (nextOrFinish) nextOrFinish.addEventListener('click', (ev) => {
          ev.preventDefault();

          const isQuestionStep = !!stepEl.querySelector('.domanda') || !!stepEl.querySelector('.risposta');
          if (isQuestionStep) {
            const questionNumber = i; // intro = 0 → Q1 = 1
            const ans = state.answers[questionNumber - 1];
            if (!ans) { alert('Seleziona una risposta per continuare.'); return; }
          }

          const lastIndex   = steps.length - 1;
          const isFinishBtn = nextOrFinish.matches(BTN_SEL.finish);
          const isLastStep  = i >= lastIndex;

          if (isFinishBtn || isLastStep) {
            const code = buildCode();
            if (!code) { alert('Risposte incomplete.'); return; }
            goResults(code);
            return;
          }

          state.stepIndex = i + 1;
          setActiveStep(steps, state.stepIndex);
        });

        const isQuestionStep = !!stepEl.querySelector('.domanda') || !!stepEl.querySelector('.risposta');
        if (isQuestionStep) attachAnswers(stepEl, i); // i=1..N (intro=0)
      });

      await loadMapping();
    })();
  })();

  // ==========================================
  // BUBBLES + MULTI-GROUP TEXT/BUTTON ANIMATIONS
  // robusto + partial wait + multi-sezione (Shopify) — citazione uniformata
  // ==========================================

  const BUBBLE_REVEAL_STAGGER   = 250;  // ms tra rivelazioni bolla
  const BUBBLE_REVEAL_DURATION  = 1000;  // ms durata bubbleReveal (0.6s)
  const TEXT_STAGGER_DEFAULT    = 100;  // ms tra elementi del gruppo
  const SAFETY_EXTRA_MS         = 300;  // margine fallback
  const SEQ_STEP_GAP            = 140;  // ms tra gli step delle sequenze custom

  // soglia PARZIALE: fai partire i testi quando è rivelata questa quota
  const MIN_REVEALED_FOR_TEXT     = 0;    // almeno N bolle
  const PERCENT_REVEALED_FOR_TEXT = 0;  // oppure % bolle (0..1)

  const animatedSections = new Set();

  // Gruppi generici (supporto underscore e dash)
  // NOTA: citazione ora è gestita come un gruppo normale, niente .animate-in speciale
  const GROUPS = [
    { name: 'heroLines', selector: '.citazione-hero p, .citazione_hero p', usesCssClass: false, stagger: 100 },
    { name: 'titles',    selector: '.title_animation, .title-animation',   usesCssClass: false, stagger: 90  },
    { name: 'paras',     selector: '.paragraph_animation, .paragraph-animation', usesCssClass: false, stagger: 80  },
    { name: 'buttons',   selector: '.button_animation, .button-animation, .cta, .button:not(.deferred-media__poster-button), a[class*="button"], [class*="btn"]', usesCssClass: false, stagger: 70 },
  ];

  /* =============== UTIL =============== */

  function qsa(scope, sel) { return Array.from(scope.querySelectorAll(sel)); }

  function waitForPartialBubbleReveals(bubbles, perBubbleStagger = BUBBLE_REVEAL_STAGGER, revealDuration = BUBBLE_REVEAL_DURATION) {
    if (!bubbles || bubbles.length === 0) return Promise.resolve();

    const total = bubbles.length;
    const targetCount = Math.min(total, Math.max(MIN_REVEALED_FOR_TEXT, Math.ceil(total * PERCENT_REVEALED_FOR_TEXT)));
    const idxTarget   = Math.max(0, targetCount - 1);
    const theoretical = idxTarget * perBubbleStagger + revealDuration + SAFETY_EXTRA_MS;

    let resolved = false;
    let revealedCount = 0;

    return new Promise(resolve => {
      const done = () => { if (!resolved) { resolved = true; resolve(); } };
      const fallback = setTimeout(done, theoretical);

      const onAnimEnd = (ev) => {
        if (ev.animationName !== 'bubbleReveal') return;
        revealedCount += 1;
        if (revealedCount >= targetCount) {
          clearTimeout(fallback);
          bubbles.forEach(b => b.removeEventListener('animationend', onAnimEnd));
          done();
        }
      };

      bubbles.forEach(bubble => bubble.addEventListener('animationend', onAnimEnd));
    });
  }

  function prepareInitialStateFor(el) {
    if (el.dataset.prepared === '1') return;
    el.style.opacity = '0';
    el.style.transform = 'translateY(20px)';
    el.style.transition = 'opacity 500ms ease-in-out, transform 500ms ease-in-out';
    el.dataset.prepared = '1';
  }

  function triggerIn(el, delayMs) {
    if (el.dataset.animated === '1') return;
    el.style.transitionDelay = `${delayMs}ms`;
    requestAnimationFrame(() => {
      el.style.opacity = '1';
      el.style.transform = 'translateY(0)';
      el.dataset.animated = '1';
    });
  }

  /* =============== PREP =============== */

  function prepareGroups(container) {
    GROUPS.forEach(group => {
      qsa(container, group.selector).forEach(prepareInitialStateFor);
    });
  }

  function prepareGlobalIfEmpty(container) {
    let found = 0;
    GROUPS.forEach(group => { found += qsa(container, group.selector).length; });
    if (found > 0) return;
    GROUPS.forEach(group => { qsa(document, group.selector).forEach(prepareInitialStateFor); });
  }

  /* =============== ANIMATE (generico) =============== */

  function animateGroup(containerOrDoc, selector, stagger = TEXT_STAGGER_DEFAULT) {
    const els = qsa(containerOrDoc, selector).filter(el => el.dataset.animated !== '1');
    if (els.length === 0) return;
    els.forEach((el, i) => triggerIn(el, i * stagger));
  }

  function animateTextGroups(container) {
    // Prima nel container
    GROUPS.forEach(group => {
      animateGroup(container, group.selector, group.stagger);
    });

    // Se non c'era nulla nel container, prova globale
    const anyInContainer = GROUPS.some(g => qsa(container, g.selector).length > 0);
    if (!anyInContainer) {
      GROUPS.forEach(group => {
        animateGroup(document, group.selector, group.stagger);
      });
    }
  }

  /* =============== SEQUENZE CUSTOM PER SHOPIFY =============== */

  // Mappa classi → tipo sequenza
  function getSeqForContainer(container) {
    if (!container) return null;
    const cl = container.classList;
    if (cl.contains('bg-media-home-section') && cl.contains('container_bubble')) return 'hero';
    if (cl.contains('sezione_custom')      && cl.contains('container_bubble')) return 'test';
    return null;
  }

  // Prepara target specifici delle due sequenze
  function prepareSequenceTargets(container) {
    const seq = getSeqForContainer(container);
    if (!seq) return;

    const selBySeq = {
      hero: [
        '.citazione-hero p, .citazione_hero p', // righe citazione (dash e underscore)
        '.button_citazione'                     // bottone citazione
      ],
      test: [
        '.titolo_test_fragranza.intestazione',
        '.testo_test_fragranza',
        '.button_test_fragranza'
      ]
    };

    (selBySeq[seq] || []).forEach(sel => {
      qsa(container, sel).forEach(prepareInitialStateFor);
    });
  }

  // Sequenza custom dopo le bolle (parziale) — tutto tramite animateGroup
  function animateCustomSequence(container) {
    const seq = getSeqForContainer(container);
    if (!seq) return;

    if (seq === 'hero') {
      // 1) citazione (righe p con leggero stagger)
      animateGroup(container, '.citazione-hero p, .citazione_hero p', 100);

      // 2) poco dopo → bottone citazione
      setTimeout(() => {
        animateGroup(container, '.button_citazione', 0);
      }, SEQ_STEP_GAP);

      return;
    }

    if (seq === 'test') {
      // 1) titolo
      animateGroup(container, '.titolo_test_fragranza', 0);

      // 2) poco dopo → testo
      setTimeout(() => {
        animateGroup(container, '.testo_test_fragranza', 0);
      }, SEQ_STEP_GAP);

      // 3) poco dopo → bottone
      setTimeout(() => {
        animateGroup(container, '.button_test_fragranza', 0);
      }, SEQ_STEP_GAP * 2);

      return;
    }
  }

  // Override gentile: se il container è uno dei due, usa la sequenza custom
  const _animateTextGroups_original = animateTextGroups;
  animateTextGroups = function(container) {
    if (getSeqForContainer(container)) {
      animateCustomSequence(container);
      return;
    }
    _animateTextGroups_original(container);
  };

  /* =============== BUBBLES SEQUENCE =============== */

  function animateBubbleSection(container) {
    // prepara gli elementi del container
    prepareGroups(container);
    // + prep extra per target custom (evita FOUC anche sui target di sequenza)
    prepareSequenceTargets(container);

    const bubbles = qsa(container, '.floating_bubble');

    // fallback: se nel container non c'è niente (solo bolle altrove, o elementi fuori)
    prepareGlobalIfEmpty(container);

    // no bolle → anima subito i contenuti (o la sequenza custom)
    if (bubbles.length === 0) {
      animateTextGroups(container);
      return;
    }

    // partial wait
    const partialReady = waitForPartialBubbleReveals(bubbles);

    // Phase 1: reveal (stagger)
    bubbles.forEach((bubble, index) => {
      const baseDelay = index * BUBBLE_REVEAL_STAGGER;
      const jitter    = Math.random() * 90;              // micro-variazione
      const revDur    = 850 + Math.random() * 450;       // 0.85s–1.3s
      const revDelay  = baseDelay + jitter;
      const floatDelay = revDelay + revDur - 50;         // fa partire il float a reveal quasi finito

      bubble.style.setProperty('--rev-duration', `${revDur}ms`);
      bubble.style.setProperty('--rev-delay',    `${revDelay}ms`);
      bubble.style.setProperty('--float-delay',  `${floatDelay}ms`);

      // aggiungo le classi subito: i delay li governa il CSS via var()
      bubble.classList.add('bubble-revealed');
      // il float scatterà dopo --float-delay, niente requestAnimationFrame qui
      bubble.classList.add('bubble-floating');
    });

    // Quando raggiungo la soglia → avvio gruppi / sequenza custom
    partialReady.then(() => {
      animateTextGroups(container);
    });
  }

  /* =============== IO + INIT =============== */

  function initBubbleSystem() {
    const containers = document.querySelectorAll('.container_bubble');
    if (containers.length === 0) return;

    // Prepara subito gli stati iniziali per evitare FOUC sul primo paint
    containers.forEach(c => {
      prepareGroups(c);
      prepareSequenceTargets(c); // anche i target custom
    });
    // Fallback globale per eventuali elementi fuori container
    prepareGlobalIfEmpty(document);

    if (!('IntersectionObserver' in window)) {
      containers.forEach(c => {
        if (!animatedSections.has(c)) {
          animatedSections.add(c);
          animateBubbleSection(c);
        }
      });
      return;
    }

    containers.forEach(container => {
      const io = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !animatedSections.has(container)) {
            animatedSections.add(container);
            animateBubbleSection(container);
            io.unobserve(container);
          }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -20px 0px' });

      io.observe(container);
    });
  }

  /* =============== Videos =============== */

  function setupVideos() {
    const deferredMediaElements = document.querySelectorAll('deferred-media');
    if (deferredMediaElements.length === 0) return;

    deferredMediaElements.forEach((deferredMedia) => {
      const posterButton = deferredMedia.querySelector('.deferred-media__poster-button');
      const video = deferredMedia.querySelector('video');
      if (!(posterButton && video)) return;

      posterButton.style.display = 'none';
      video.style.display = 'block';

      ['muted', 'autoplay', 'loop', 'playsinline'].forEach(attr => video.setAttribute(attr, ''));
      video.removeAttribute('controls');

      const playVideo = () => video.play().catch(e => console.log('Autoplay prevented:', e.name));
      if (video.readyState >= 2) playVideo();
      else video.addEventListener('loadeddata', playVideo, { once: true });
    });
  }

  /* =============== Init =============== */

  requestAnimationFrame(() => {
    setupVideos();
    initBubbleSystem();
  });

  // API pubblica per rianimare (es. on section reload Shopify)
  window.reinitBubbles = () => {
    animatedSections.clear();
    initBubbleSystem();
  };

  /* Card prodotto e collezioni con funziona tab */
  document.querySelectorAll('.collection-card, .product-card').forEach((card) => {
    const outerLink = card.querySelector('.collection-card__link, .product-card__link');
    if (!outerLink) return;

    // trova CTA interne (link o bottoni) che non siano l’overlay della card
    const innerCtas = card.querySelectorAll('a.link, a.button, button.link, button.button');
    innerCtas.forEach((cta) => {
      if (cta === outerLink) return;

      // escludi dal tab order e dagli screen reader
      cta.setAttribute('tabindex', '-1');
      cta.setAttribute('aria-hidden', 'true');
      cta.setAttribute('role', 'presentation');

      // click → sempre sul link della card
      cta.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        outerLink.click();
      });

      // enter/space da tastiera → sempre sul link della card
      cta.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          e.stopPropagation();
          outerLink.click();
        }
      });
    });
  });

  document.querySelectorAll('.card-gallery').forEach(el => {
    el.addEventListener('click', e => e.stopPropagation());
  });
  const arrows = document.querySelectorAll(
    '.product-card .slideshow-control--next, .product-card .slideshow-control--previous'
  );
  arrows.forEach(btn => {
    btn.addEventListener('click', e => {
      e.stopPropagation();
    }, true);

    btn.addEventListener('keydown', e => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.stopPropagation();
      }
    }, true);
  });
  
  /* Personalizzazione prodotto — tramite varianti */
  (function () {
    const openBtn  = document.getElementById('open-personalizer');
    const editBtn  = document.getElementById('edit-personalizer');
    const summary  = document.getElementById('pers-summary');
    const modal    = document.getElementById('personalizer');
    if (!modal || !openBtn || !summary) return;

    const root       = openBtn.closest('.product-form-buttons');
    const pfc        = root.closest('product-form-component');
    const productUrl = pfc?.dataset?.productUrl || window.location.pathname;
    const productId  = pfc?.dataset?.productId || pfc?.getAttribute('data-product-id') || null;

    const VAL = {
      no:     root.dataset.persValueNo     || 'No',
      bottle: root.dataset.persValueBottle || 'Bottle',
      stick:  root.dataset.persValueStick  || 'Sticks',
      both:   root.dataset.persValueBoth   || 'Both',
    };

    // ----- Elements modale
    const backdrop   = modal.querySelector('.PersonalizerModal__backdrop');
    const closeBtns  = modal.querySelectorAll('[data-close]');
    const step1      = modal.querySelector('.Step[data-step-index="1"]');
    const step2      = modal.querySelector('.Step[data-step-index="2"]');
    const tabs       = modal.querySelectorAll('.PersTab');

    const previewImg  = modal.querySelector('#preview-image');
    const previewText = modal.querySelector('#preview-text');

    const bottleInput       = modal.querySelector('#bottle-text');
    const bottleCount       = modal.querySelector('#bottle-count');
    const bottleCountInline = modal.querySelector('#bottle-count-inline');

    const stickInput        = modal.querySelector('#stick-text');
    const stickCount        = modal.querySelector('#stick-count');
    const stickCountInline  = modal.querySelector('#stick-count-inline');

    // Summary in PDP
    const bottleRow = document.getElementById('summary-bottle-row');
    const stickRow  = document.getElementById('summary-stick-row');
    const bottleOut = document.getElementById('summary-bottle');
    const stickOut  = document.getElementById('summary-stick');

    // Footer modale
    const footerExtra = modal.querySelector('#pers-extra');
    const footerTotal = modal.querySelector('#pers-total');

    // Anteprime
    const previewBottleSrc = modal.dataset.previewBottleSrc || '';
    const previewStickSrc  = modal.dataset.previewStickSrc  || '';

    // Stato
    let currentStep = 1;
    const norm = (s) => String(s || '').trim().toLowerCase();

    // ===== Helpers PDP (prezzo + nota) =====
    function getPriceContainer() {
      const c1 = document.querySelector('[ref="priceContainer"]');
      if (c1) return c1;
      return document.querySelector('.product-price, .price, [data-price-container]') || null;
    }
    function getPersNoteEls() {
      const container = getPriceContainer() || document;
      const note = container.querySelector('#pers-note') || document.getElementById('pers-note');
      const amt  = container.querySelector('#pers-note-amount') || document.getElementById('pers-note-amount');
      return { note, amt };
    }

    function bindMaxLenMessageFor(inputEl) {
      if (!inputEl) return;
      const field   = inputEl.closest('.Field');
      const msgEl   = field ? field.querySelector('.MaxCharsMsg') : null;
      if (!msgEl) return;

      const max = Number(inputEl.getAttribute('maxlength') || 0);
      const update = () => {
        const show = max > 0 && inputEl.value.length >= max;
        msgEl.hidden = !show;
      };
      inputEl.addEventListener('input', update);
      update(); // stato iniziale
    }

    // ----- Money
    function formatMoney(cents) {
      const moneyFormat = root?.dataset.moneyFormat || '';
      try {
        if (typeof Shopify !== 'undefined' && Shopify.formatMoney && moneyFormat) {
          return Shopify.formatMoney(Math.round(cents), moneyFormat);
        }
      } catch {}
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: root?.dataset.currency || 'EUR'
      }).format(Math.round(cents) / 100);
    }

    // ----- Variant id corrente
    function getVariantInput(){ return pfc?.querySelector('input[ref="variantId"]') || null; }
    function getCurrentVariantId(){
      const v = Number(getVariantInput()?.value);
      return Number.isFinite(v) && v > 0 ? v : null;
    }

    // ----- variant-picker container (per trovare fieldset dei radio)
    function getVariantPickerEl() {
      const all = Array.from(document.querySelectorAll('variant-picker'));
      if (productId) {
        const byId = all.find(vp => vp.dataset.productId === String(productId));
        if (byId) return byId;
      }
      const urlBare = (productUrl || '').split('?')[0];
      if (urlBare) {
        const byUrl = all.find(vp => (vp.dataset.productUrl || '').split('?')[0] === urlBare);
        if (byUrl) return byUrl;
      }
      return all[0] || null;
    }
    function getVariantPickerContainer() {
      const vp = getVariantPickerEl();
      if (!vp) return null;
      return vp.querySelector('form.variant-picker__form') || vp;
    }

    // ===== PRODUCT JSON & OPTION INDEX
    let productJson = null;
    let persOptionIndex = -1;               // 0-based
    let persOptionIndexFromDom = -1;

    function detectPersIndexFromDom(fs) {
      const any = fs?.querySelector('input[type="radio"][data-input-id]');
      if (!any) return -1;
      const pos = parseInt(String(any.dataset.inputId).split('-')[0], 10);
      return Number.isFinite(pos) ? (pos - 1) : -1;
    }

    async function ensureProductJson() {
      if (productJson) return productJson;
      const url = (productUrl || window.location.pathname).replace(/\/$/, '') + '.js';
      try {
        const r = await fetch(url, { credentials: 'same-origin' });
        productJson = await r.json();
        return productJson;
      } catch {
        productJson = null;
        return null;
      }
    }

    // utils varianti
    function getVariantOptionsArr(v) {
      if (!v) return [];
      if (Array.isArray(v.options) && v.options.length) return v.options.slice();
      const out = [];
      if (v.option1 != null) out.push(String(v.option1));
      if (v.option2 != null) out.push(String(v.option2));
      if (v.option3 != null) out.push(String(v.option3));
      return out;
    }
    function vById(id) { return productJson?.variants?.find(v => Number(v.id) === Number(id)) || null; }

    function optionsMatchLike(vo, wanted) {
      if (!Array.isArray(vo) || !Array.isArray(wanted) || vo.length !== wanted.length) return false;
      for (let i=0;i<wanted.length;i++){
        const cand = norm(vo[i]); const w = norm(wanted[i]);
        if (i === persOptionIndex) {
          if (!(cand === w || cand.includes(w) || w.includes(cand))) return false;
        } else {
          if (cand !== w) return false;
        }
      }
      return true;
    }

    function vByOptions(optsArr) {
      if (!productJson) return null;
      return productJson.variants.find(v => optionsMatchLike(getVariantOptionsArr(v), optsArr)) || null;
    }

    function findVariantWithPersValueLikeCurrent(curV, targetVal) {
      if (!curV || persOptionIndex < 0 || !productJson) return null;
      const curOpts = getVariantOptionsArr(curV);
      if (!curOpts.length) return null;

      const exactOpts = curOpts.slice(); exactOpts[persOptionIndex] = targetVal;
      const vExact = vByOptions(exactOpts); if (vExact) return vExact;

      const othersEqual = (v) => {
        const vo = getVariantOptionsArr(v);
        if (vo.length !== curOpts.length) return false;
        for (let i=0;i<vo.length;i++){
          if (i===persOptionIndex) continue;
          if (norm(vo[i]) !== norm(curOpts[i])) return false;
        }
        return true;
      };
      const want = norm(targetVal);
      const persFuzzy = (v) => {
        const vo = getVariantOptionsArr(v);
        const cand = norm(vo[persOptionIndex] ?? '');
        return cand === want || cand.includes(want) || want.includes(cand);
      };

      const vSameOthers = productJson.variants.find(v => othersEqual(v) && persFuzzy(v));
      if (vSameOthers) return vSameOthers;

      return productJson.variants.find(persFuzzy) || null;
    }

    function priceForPersValueLikeCurrent(curV, targetVal) {
      const v = findVariantWithPersValueLikeCurrent(curV, targetVal);
      if (!v || v.price == null) return null;
      const cents = Math.round(Number(v.price));
      return Number.isFinite(cents) ? cents : null;
    }

    function computeFees(curV) {
      if (!curV) return { pNo:null, pBottle:null, pStick:null, pBoth:null, feeBottle:0, feeStick:0, feeBoth:0 };

      const pNo     = priceForPersValueLikeCurrent(curV, VAL.no);
      const pBottle = priceForPersValueLikeCurrent(curV, VAL.bottle);
      const pStick  = priceForPersValueLikeCurrent(curV, VAL.stick);
      const pBoth   = priceForPersValueLikeCurrent(curV, VAL.both);

      const feeBottle = (pBottle != null && pNo != null) ? Math.max(0, pBottle - pNo) : 0;
      const feeStick  = (pStick  != null && pNo != null) ? Math.max(0, pStick  - pNo) : 0;
      const feeBoth   = (pBoth   != null && pNo != null) ? Math.max(0, pBoth   - pNo) : Math.max(0, feeBottle + feeStick);

      return { pNo, pBottle, pStick, pBoth, feeBottle, feeStick, feeBoth };
    }

    // ----- trova il fieldset della personalizzazione + indice opzione
    function findPersControl() {
      const container = getVariantPickerContainer();
      if (!container) return null;

      const fieldsets = Array.from(container.querySelectorAll('fieldset'))
        .filter(fs => fs.querySelector('input[type="radio"]'));

      if (!fieldsets.length) return null;

      const want = { no:norm(VAL.no), bottle:norm(VAL.bottle), stick:norm(VAL.stick), both:norm(VAL.both) };
      function scoreFs(fs){
        const radios = Array.from(fs.querySelectorAll('input[type="radio"]'));
        const labelsMap = new Map();
        radios.forEach(r => {
          const lab = r.closest('label') || fs.querySelector(`label[for="${r.id}"]`);
          const t = lab?.querySelector('.variant-option__checkbox-label__text')?.textContent || lab?.textContent || '';
          labelsMap.set(r, norm(t));
        });
        const has = (val) => radios.some(r => norm(r.value)===val || norm(r.dataset.optionValue||'')===val || (labelsMap.get(r)||'').includes(val));
        const hits = [want.no, want.bottle, want.stick, want.both].filter(v => has(v)).length;
        return { fs, radios, labelsMap, hits };
      }

      let best = null;
      for (const fs of fieldsets) {
        const s = scoreFs(fs);
        if (!best || s.hits > best.hits) best = s;
      }
      if (!best || best.hits < 2) return null;

      const idxDom = detectPersIndexFromDom(best.fs);
      if (idxDom >= 0) persOptionIndexFromDom = idxDom;

      return {
        set(valWanted) {
          const radios = Array.from(best.fs.querySelectorAll('input[type="radio"]'));
          const wanted = norm(valWanted);
          let input = radios.find(i => norm(i.value)===wanted || norm(i.dataset.optionValue||'')===wanted);
          if (!input) {
            input = radios.find(i => {
              const lab = i.closest('label') || best.fs.querySelector(`label[for="${i.id}"]`);
              const t = lab?.querySelector('.variant-option__checkbox-label__text')?.textContent || lab?.textContent || '';
              return norm(t).includes(wanted);
            });
          }
          if (!input || input.disabled) return false;

          const active   = document.activeElement;
          const selStart = active?.selectionStart ?? null;
          const selEnd   = active?.selectionEnd ?? null;

          const label = input.closest('label') || best.fs.querySelector(`label[for="${input.id}"]`);
          if (label && typeof label.click === 'function') label.click();
          else { input.checked = true; input.dispatchEvent(new Event('input', {bubbles:true})); input.dispatchEvent(new Event('change',{bubbles:true})); }

          if (active && (active === bottleInput || active === stickInput)) {
            setTimeout(() => {
              active.focus();
              try {
                if (selStart != null && selEnd != null && typeof active.setSelectionRange === 'function') {
                  active.setSelectionRange(selStart, selEnd);
                }
              } catch {}
            }, 0);
          }
          return true;
        }
      };
    }

    // ====== PRICE CONTAINER OBSERVER (no loop) ======
    let priceMo;
    function observePriceContainer() {
      priceMo?.disconnect();
      const pc = getPriceContainer();
      if (!pc) return;
      priceMo = new MutationObserver(() => {
        refreshFooterAndNote();
      });
      priceMo.observe(pc, { childList: true, subtree: true });
    }

    // ----- UI helpers (properties)
    function ensurePropertyInput(name) {
      const form = root.closest('form');
      if (!form) return null;
      const sel = form.querySelector(`input[name="properties[${name}]"]`);
      if (sel) return sel;
      const inp = document.createElement('input');
      inp.type = 'hidden';
      inp.name = `properties[${name}]`;
      form.appendChild(inp);
      return inp;
    }
    function removePropertyInputByNames(names = []) {
      const form = root.closest('form');
      if (!form) return;
      names.forEach((n) => {
        const el = form.querySelector(`input[name="properties[${n}]"]`);
        if (el) el.remove();
      });
    }
    function setProperty(name, value) {
      const form = root.closest('form');
      if (!form || !name) return;
      removePropertyInputByNames(['Bottle engraving','Sticks engraving', name]);
      if (!value) return;
      const inp = ensurePropertyInput(name);
      if (inp) inp.value = value;
    }

    function updateSummary() {
      const b = bottleInput.value.trim();
      const s = stickInput.value.trim();
      if (bottleOut) bottleOut.textContent = b || '';
      if (stickOut)  stickOut.textContent  = s || '';
      if (bottleRow) bottleRow.classList.toggle('hidden', !b);
      if (stickRow)  stickRow.classList.toggle('hidden', !s);
      const hasAny = Boolean(b || s);
      summary.classList.toggle('hidden', !hasAny);
      openBtn.classList.toggle('hidden', hasAny);
    }

    function computeWantedValue() {
      const hasBottle = !!norm(bottleInput?.value);
      const hasStick  = !!norm(stickInput?.value);
      if (!hasBottle && !hasStick) return VAL.no;
      if (hasBottle && hasStick)   return VAL.both;
      if (hasBottle)               return VAL.bottle;
      return VAL.stick;
    }

    // debounced
    let setVariantTmr = null;
    function setPersVariantFromInputs() {
      clearTimeout(setVariantTmr);
      setVariantTmr = setTimeout(() => {
        const ctrl = findPersControl();
        if (!ctrl) return;
        ctrl.set(computeWantedValue());
        setTimeout(() => { wireVariantInputObserver(); refreshFooterAndNote(); }, 80);
      }, 120);
    }

    // Fees + UI prezzo
    async function refreshFooterAndNote() {
      await ensureProductJson();

      if (persOptionIndexFromDom >= 0) {
        persOptionIndex = persOptionIndexFromDom;
      } else if (persOptionIndex < 0 && Array.isArray(productJson?.options)) {
        const opts = productJson.options.map(norm);
        const candidates = ['personaliz','personalizzazione','custom','incisione'];
        let idx = -1;
        for (let i=0;i<opts.length;i++){
          const o = opts[i];
          if (candidates.some(c => o.includes(c))) { idx = i; break; }
        }
        persOptionIndex = idx >= 0 ? idx : 2;
      }

      const curId = getCurrentVariantId();
      const curV  = curId ? vById(curId) : null;
      if (!curV) return;

      const { feeBottle, feeStick } = computeFees(curV);

      const totalCents = Math.round(Number(curV.price) || 0);
      if (footerTotal) footerTotal.textContent = formatMoney(totalCents);

      let stepExtra = 0;
      if (currentStep === 1) {
        stepExtra = norm(bottleInput.value) ? feeBottle : 0;
      } else {
        stepExtra = norm(stickInput.value) ? feeStick : 0;
      }

      if (footerExtra) {
        if (stepExtra > 0) {
          footerExtra.textContent = `(+${formatMoney(stepExtra)})`;
          footerExtra.classList.remove('hidden');
        } else {
          footerExtra.textContent = '';
          footerExtra.classList.add('hidden');
        }
      }

      const totalExtra = (norm(bottleInput.value) ? feeBottle : 0) + (norm(stickInput.value) ? feeStick : 0);

      priceMo?.disconnect();
      const { note: persNote, amt: persNoteAmount } = getPersNoteEls();
      if (persNote && persNoteAmount) {
        if (totalExtra > 0) {
          persNoteAmount.textContent = formatMoney(totalExtra);
          persNote.classList.remove('hidden');
        } else {
          persNoteAmount.textContent = '';
          persNote.classList.add('hidden');
        }
      }
      observePriceContainer();
    }

    // ---- Helpers riepilogo
    function summaryRowLabel(rowSel) {
      const row = document.querySelector(rowSel);
      if (!row) return '';
      const firstNodeText = row.childNodes[0]?.textContent ?? '';
      return String(firstNodeText).replace(':', '').trim();
    }
    function summaryValue(sel) {
      const el = document.querySelector(sel);
      return (el?.textContent || '').trim();
    }

    function applyCurrentValues() {
      updateSummary();

      const bottleLabel = summaryRowLabel('#summary-bottle-row');
      const stickLabel  = summaryRowLabel('#summary-stick-row');

      const bottleVal = summaryValue('#summary-bottle');
      const stickVal  = summaryValue('#summary-stick');

      removePropertyInputByNames(['Bottle engraving','Sticks engraving','Testo bottiglia','Testo bottiglietta','Testo bastoncino']);

      if (bottleLabel && bottleVal) setProperty(bottleLabel, bottleVal);
      if (stickLabel  && stickVal)  setProperty(stickLabel,  stickVal);

      setPersVariantFromInputs();
    }

    // ----- STEP & UI
    const btnNexts    = modal.querySelectorAll('.pers-next');
    const btnConfirms = modal.querySelectorAll('.pers-confirm');
    function showAll(list){ list.forEach(el => el.classList.remove('hidden')); }
    function hideAll(list){ list.forEach(el => el.classList.add('hidden')); }

    function gotoStep(step) {
      currentStep = step;
      if (step === 1) {
        step1.classList.add('is-active'); step2.classList.remove('is-active');
        tabs[0]?.classList.add('is-active'); tabs[1]?.classList.remove('is-active');
        if (previewBottleSrc) previewImg.src = previewBottleSrc;
        previewText.textContent = bottleInput.value;
        showAll(btnNexts); hideAll(btnConfirms);
      } else {
        step1.classList.remove('is-active'); step2.classList.add('is-active');
        tabs[0]?.classList.remove('is-active'); tabs[1]?.classList.add('is-active');
        if (previewStickSrc) previewImg.src = previewStickSrc;
        previewText.textContent = stickInput.value;
        hideAll(btnNexts); showAll(btnConfirms);
      }
      refreshFooterAndNote();

      // 🔧 ricalcola focusables e porta il focus al campo corretto dello step
      setTimeout(() => {
        collectFocusable(modal);
        (step === 1 ? bottleInput : stickInput)?.focus();
      }, 0);
    }

    // === Focus Trap ===
    let focusableEls = [];
    let firstFocusableEl = null;
    let lastFocusableEl = null;
    let prevActiveElement = null;

    // visibilità robusta
    function isVisible(el) {
      if (!el) return false;
      if (el.closest('.hidden')) return false;
      const style = window.getComputedStyle(el);
      if (style.visibility === 'hidden' || style.display === 'none') return false;
      const rect = el.getBoundingClientRect();
      if (rect.width === 0 && rect.height === 0) return false;
      return true;
    }

    function collectFocusable(modalRoot) {
      focusableEls = Array.from(
        modalRoot.querySelectorAll(
          'a[href], button:not([disabled]), textarea, input[type="text"], input[type="radio"], input[type="checkbox"], select, [tabindex]:not([tabindex="-1"])'
        )
      ).filter(isVisible);
      firstFocusableEl = focusableEls[0] || null;
      lastFocusableEl  = focusableEls[focusableEls.length - 1] || null;
    }

    function handleTrapTab(e) {
      if (e.key !== 'Tab') return;

      // se l'elemento attivo non è più visibile (perché lo step è cambiato), rientra
      if (!isVisible(document.activeElement)) {
        e.preventDefault();
        collectFocusable(modal);
        (firstFocusableEl || modal.querySelector('.PersClose') || modal).focus();
        return;
      }

      if (!focusableEls.length) return;

      if (!modal.contains(document.activeElement)) {
        e.preventDefault();
        (firstFocusableEl || modal.querySelector('.PersClose') || modal).focus();
        return;
      }

      if (e.shiftKey) {
        if (document.activeElement === firstFocusableEl) {
          e.preventDefault();
          lastFocusableEl?.focus();
        }
      } else {
        if (document.activeElement === lastFocusableEl) {
          e.preventDefault();
          firstFocusableEl?.focus();
        }
      }
    }

    function trapFocus(modalRoot) {
      collectFocusable(modalRoot);
      modalRoot.addEventListener('keydown', handleTrapTab);
    }
    function releaseFocus(modalRoot) {
      modalRoot.removeEventListener('keydown', handleTrapTab);
    }

    // ----- EVENTI
    const openModal = async () => {
      await ensureProductJson();
      prevActiveElement = document.activeElement;

      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.setAttribute('scroll-lock', '');
      const head = document.querySelector('header'); if (head?.style) head.style.zIndex = '0';

      gotoStep(1);
      setPersVariantFromInputs();

      setTimeout(() => {
        trapFocus(modal);
        collectFocusable(modal);
        (modal.querySelector('.PersClose') || firstFocusableEl || modal).focus();
      }, 10);
    };

    function closeModal() {
      applyCurrentValues();

      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.removeAttribute('scroll-lock');
      const head = document.querySelector('header'); if (head?.style) head.style.zIndex = '';

      releaseFocus(modal);
      if (prevActiveElement && typeof prevActiveElement.focus === 'function') {
        prevActiveElement.focus();
      } else {
        openBtn?.focus();
      }
    }

    openBtn.addEventListener('click', openModal);
    editBtn?.addEventListener('click', openModal);
    backdrop.addEventListener('click', closeModal);
    closeBtns.forEach(b => b.addEventListener('click', closeModal));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') closeModal();
    });

    tabs.forEach(t => t.addEventListener('click', () => gotoStep(Number(t.dataset.stepTarget || '1'))));
    btnNexts.forEach(btn => btn.addEventListener('click', () => gotoStep(2)));
    btnConfirms.forEach(btn => btn.addEventListener('click', () => { applyCurrentValues(); closeModal(); }));

    // Input handlers
    function onBottleInput() {
      if (step1.classList.contains('is-active')) previewText.textContent = bottleInput.value;
      if (bottleCount)       bottleCount.textContent = bottleInput.value.length;
      if (bottleCountInline) bottleCountInline.textContent = bottleInput.value.length;
      setPersVariantFromInputs();
    }
    function onStickInput() {
      if (step2.classList.contains('is-active')) previewText.textContent = stickInput.value;
      if (stickCount)       stickCount.textContent = stickInput.value.length;
      if (stickCountInline) stickCountInline.textContent = stickInput.value.length;
      setPersVariantFromInputs();
    }
    bottleInput.addEventListener('input', onBottleInput);
    stickInput .addEventListener('input', onStickInput);

    bindMaxLenMessageFor(bottleInput);
    bindMaxLenMessageFor(stickInput);

    // Submit → properties
    const productForm = root.closest('form');
    if (productForm) productForm.addEventListener('submit', () => applyCurrentValues());

    // osserva input[ref="variantId"]
    function wireVariantInputObserver() {
      const vInput = getVariantInput();
      if (!vInput || vInput._persObserved) return;
      new MutationObserver(() => setTimeout(refreshFooterAndNote, 0))
        .observe(vInput, { attributes: true, attributeFilter: ['value'] });
      vInput._persObserved = true;
    }
    const onVariantEvent = () => { wireVariantInputObserver(); setTimeout(refreshFooterAndNote, 0); };
    document.addEventListener('variant:update', onVariantEvent, { passive: true });
    document.addEventListener('variant:change', onVariantEvent, { passive: true });

    // ----- init
    updateSummary();
    wireVariantInputObserver();
    observePriceContainer();
    requestAnimationFrame(() => {
      setPersVariantFromInputs();
      refreshFooterAndNote();
    });
  })();

    /* Selettore lingua custom — animazione altezza reale + nascondi lingua attiva */
    (function () {
      const wrappers = document.querySelectorAll('[data-custom-select]');

      const closeAll = (except = null) => {
        wrappers.forEach(w => {
          if (w !== except) {
            w.classList.remove('is-open');
            const trg = w.querySelector('.custom-select-trigger');
            const dd  = w.querySelector('.custom-select-dropdown');
            trg?.setAttribute('aria-expanded', 'false');
            if (dd) dd.style.setProperty('--menu-h', '0px');
          }
        });
      };

      const setMenuHeight = (dd) => {
        dd.style.setProperty('--menu-h', dd.scrollHeight + 'px');
      };

      wrappers.forEach(wrapper => {
        const trigger      = wrapper.querySelector('.custom-select-trigger');
        const dropdown     = wrapper.querySelector('.custom-select-dropdown');
        const hiddenSelect = wrapper.querySelector('.localization-form__select');
        const valueDisplay = wrapper.querySelector('.custom-select-value');

        // collega trigger ↔ listbox per a11y
        const listboxId = dropdown.id || `cs-listbox-${Math.random().toString(36).slice(2)}`;
        dropdown.id = listboxId;
        trigger.setAttribute('aria-controls', listboxId);

        // helper: costruisce il menu a partire dalla <select>, escludendo l'opzione attiva
        const buildDropdown = () => {
          const activeValue = hiddenSelect.value;
          dropdown.innerHTML = ''; // reset

          const opts = Array.from(hiddenSelect.options)
            .filter(o => o.value && o.value !== activeValue);

          // crea bottoni opzione
          opts.forEach(o => {
            const btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'custom-select-option';
            btn.setAttribute('role', 'option');
            btn.dataset.value = o.value;
            btn.dataset.lang = o.getAttribute('lang') || o.value;
            btn.setAttribute('aria-selected', 'false');
            btn.textContent = (o.textContent || '').trim();
            dropdown.appendChild(btn);

            // listener selezione
            btn.addEventListener('click', () => {
              // aggiorna UI
              valueDisplay.textContent = btn.textContent;
              // aggiorna hidden select
              hiddenSelect.value = btn.dataset.value;

              // chiudi
              wrapper.classList.remove('is-open');
              trigger.setAttribute('aria-expanded', 'false');
              dropdown.style.setProperty('--menu-h', '0px');

              // dispatch change per innescare il cambio lingua
              hiddenSelect.dispatchEvent(new Event('change', { bubbles: true }));

              // ricostruisci il menu per nascondere la nuova attiva
              buildDropdown();
              trigger.focus();
            });
          });

          // aggiorna il testo nel trigger in base alla selezionata
          const selectedOption = hiddenSelect.options[hiddenSelect.selectedIndex];
          if (selectedOption) {
            valueDisplay.textContent = (selectedOption.textContent || '').trim();
          }

          // disabilita se non ci sono altre lingue
          const hasChoices = dropdown.querySelector('.custom-select-option') !== null;
          trigger.disabled = !hasChoices;
          trigger.setAttribute('aria-disabled', String(!hasChoices));
          wrapper.classList.toggle('is-disabled', !hasChoices);

          // se è aperto, ricalcola l'altezza
          if (wrapper.classList.contains('is-open')) setMenuHeight(dropdown);
        };

        // osserva cambi dimensione contenuto (responsive / font / etc.)
        const ro = new ResizeObserver(() => {
          if (wrapper.classList.contains('is-open')) setMenuHeight(dropdown);
        });
        ro.observe(dropdown);

        // inizializza menu
        buildDropdown();

        // toggle open/close
        trigger.addEventListener('click', () => {
          if (trigger.disabled) return;
          const expanded = trigger.getAttribute('aria-expanded') === 'true';
          if (!expanded) {
            closeAll(wrapper);
            wrapper.classList.add('is-open');
            trigger.setAttribute('aria-expanded', 'true');
            setMenuHeight(dropdown);
            // focus alla prima opzione disponibile
            const first = dropdown.querySelector('.custom-select-option');
            first?.focus({ preventScroll: true });
          } else {
            wrapper.classList.remove('is-open');
            trigger.setAttribute('aria-expanded', 'false');
            dropdown.style.setProperty('--menu-h', '0px');
            trigger.focus();
          }
        });

        // click fuori
        document.addEventListener('click', (e) => {
          if (!wrapper.contains(e.target)) {
            wrapper.classList.remove('is-open');
            trigger.setAttribute('aria-expanded', 'false');
            dropdown.style.setProperty('--menu-h', '0px');
          }
        });

        // tastiera: apri/chiudi dal trigger
        trigger.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); trigger.click(); }
          if (e.key === 'ArrowDown') { e.preventDefault(); if (trigger.getAttribute('aria-expanded') !== 'true') trigger.click(); }
        });

        // tastiera nel listbox: roving focus
        dropdown.addEventListener('keydown', (e) => {
          const focusables = Array.from(dropdown.querySelectorAll('.custom-select-option'));
          const i = focusables.indexOf(document.activeElement);
          if (!focusables.length) return;

          if (e.key === 'ArrowDown') { e.preventDefault(); (focusables[i + 1] || focusables[0])?.focus(); }
          else if (e.key === 'ArrowUp') { e.preventDefault(); (focusables[i - 1] || focusables.at(-1))?.focus(); }
          else if (e.key === 'Home') { e.preventDefault(); focusables[0]?.focus(); }
          else if (e.key === 'End') { e.preventDefault(); focusables.at(-1)?.focus(); }
          else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); document.activeElement?.click(); }
          else if (e.key === 'Escape') {
            wrapper.classList.remove('is-open');
            trigger.setAttribute('aria-expanded', 'false');
            dropdown.style.setProperty('--menu-h', '0px');
            trigger.focus();
          }
        });

        // se qualcuno aggiorna la <select> da fuori, ricostruisci (robustezza)
        hiddenSelect.addEventListener('change', () => buildDropdown());
      });
    })();
});